import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { INITIAL_LOADER_SCREEN, LANDSCAPE } from "../../config/Constant";
import { useTranslation } from "react-i18next";
import { useCssStyle } from "../../customHook/getCssStyle";
import { setGoHome, setShowLoginModal } from "../../Redux/Reducers/appConfigReducer";
import { setChannelList, setCurrentTv, setIsChannelDataLoading, setIsMediaListLoading, setIsRoomRemoteLoading, setRoomRemoteDetails } from "../../Redux/Reducers/tvRemoteReducer";
import { channelApi, fetchChannelList, getMediaStreaming, getremoteAccessToken, mediaStreamingLaunchApp } from "../../Redux/Actions/tvRemoteAction";
import TVSelect_Potrait from "./tvRemote_potrait/TVSelect_potrait";
import Remote_Landscape from "./tvRemote_landscape/Remote_landscape";
import FetchingDataScreen from "../../components/fetchingDataScreen";
import { getDataLoadingScreen } from "../../js/getDataLoadingScreen";
import InfoPopupModal from "../../components/infoPopupModal";
import triggerHapticFeedback from "../../js/vibration";
import { getToken } from "./helper";
import { setRenderFlashMessage } from "../../Redux/Actions/appConfigAction";
import TVSelect_Landscape from "./tvRemote_landscape/TVSelect_landscape";
import { Text } from "react-native";
import Remote_Potrait from "./tvRemote_potrait/Remote_potrait";

const days = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday"
]

const months = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec"
]


export const TVRemote = (props) => {
    const { appOrientation } = useSelector(state => (state.appConfigSlice));

    const dispatch = useDispatch();
    const { t } = useTranslation();
    const getStyles = useCssStyle();

    const { isLoggedIn } = useSelector(state => state.appConfigSlice);
    const { currentTv, roomRemoteDetails, channelData, categoryGrouping, languageGrouping } = useSelector(state => state.tvRemoteSlice);
    const { ipgExtraInfo } = useSelector(state => state.deviceConfigSlice);
    const channelScheduleHours = ipgExtraInfo?.ipgBrandingInfo?.channelScheduleHours || "0";

    const [channelObj, setChannelObj] = useState({
        width: 1000,
        longestslots: 0,
        gettingChannelList: true,
        channelList:[],
        selectedCategory: "All categories",
        selectedLanguage: "All languages",
        allCategoryList: [],
        allLanguageList: [],
        categoryList: [],
        languageList: [],
        apiCalled: false,
        currentTime: new Date()
    });

    const updateChannelObj = (obj) => {
        setChannelObj((prev) => ({
            ...prev,
            ...obj
        }))
    }

    const [loaderState, setLoaderState] = useState({
        showLoader: "",
        loaderMessage: ""
    });
    const [initialLoading, setInitialLoading] = useState(true);

    const [fetchApiError, setFetchApiError] = useState({
        errorStatus: false,
        errorMessage: "",
        onContinueFunc: null,
        primaryBtnLabel: "",
        onCloseFunc: null,
        secondaryBtnLabel: ""
    });

    const getTimeSlots = () => {
        let hours = 0, min = 0, dateforGuide = "", period = "AM"
        let dateAndTime = ""
        let scheduledate = new Date();
        dateforGuide = <Text style={getStyles([""])}>
                ${days[scheduledate.getDay()]} ${months[scheduledate.getMonth()]} ${scheduledate.getDate()} ${scheduledate.getFullYear()}
            </Text>

        if (channelData.length > 0) {
            hours = scheduledate.getHours()
            period = hours <= 12 ? "AM" : "PM"
            min = scheduledate.getMinutes()
            dateAndTime += `${dateforGuide}${<Text style={getStyles(["label"])}>${hours > 12 ? hours - 12 : hours}:${min > 20 ? 30 : "00"}${period}</Text>}`
            // console.log('this.state.longestslots', channelObj.longestslots)

            for (let i = 0; i < channelObj?.longestslots-1; i++) {
                if (min < 29) {
                    min = 30
                    dateAndTime += <Text style={getStyles(["label"])}>${hours > 12 ? hours - 12 : hours}:${min}${period}</Text>
                } else {
                    if (hours < 24) { hours = hours + 1 } else { hours = 0 }
                    min = 0
                    dateAndTime += <Text style={getStyles(["label"])}>${hours > 12 ? hours - 12 : hours}:${"00"}${period}</Text>
                }
            }
            //return dateAndTime
            return dateAndTime
        } else {
            return dateforGuide
        }

    }

    const getwidth = () => {
        let longestslots = 0, slot = 0
        if (channelData?.length > 0) {
            channelData.map((itrator) => {
                itrator.schedules.map((itr) => {
                    if (itr.duration > 59) {
                        slot = slot + 2
                    } else {
                        slot = slot + 1 
                    }
                })
                if (longestslots < slot) {
                    longestslots = slot
                }
                slot = 0
            })
        } else {
            longestslots = 2
        }
        if (longestslots < 2) {
            return { width: 2 * 163.2 + 60, longestslots: 2 };
        } else {
            return { width: longestslots * 163.2 + 60, longestslots: longestslots };
        }
    }
    useEffect(() => {
        if(channelData){
            let widthObj = getwidth() || {};
            updateChannelObj({
                ...widthObj,
                channelList: channelData,
                gettingChannelList: false,
                categoryList: Object.keys(categoryGrouping || {}), 
                languageList: Object.keys(languageGrouping || {}),
                allCategoryList: categoryGrouping, 
                allLanguageList: languageGrouping, 
                apiCalled: true,
            })
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [channelData, categoryGrouping, languageGrouping])

    useEffect(() =>  {
        if(channelObj?.selectedCategory !==  "All categories"  && channelObj?.selectedLanguage === "All languages"){
            let filteredChannelList = channelObj?.allCategoryList[channelObj.selectedCategory];

            let channelListObj = setChannelListHandler(filteredChannelList)
            updateChannelObj({
                ...channelListObj,
                languageList: setLanguageOptionsHandler(filteredChannelList)
            })
            
        } else if (channelObj?.selectedCategory === "All categories" && channelObj?.selectedLanguage !== "All languages"){
            let filteredChannelList = channelObj.allLanguageList[channelObj.selectedLanguage];

            let channelListObj = setChannelListHandler(filteredChannelList)
            updateChannelObj({
                ...channelListObj,
                categoryList: setCategoryOptionsHandler(filteredChannelList)
            })
        } else if (channelObj?.selectedCategory !== "All categories" && channelObj?.selectedLanguage !== "All languages"){
            let categoryList = channelObj.allCategoryList[channelObj.selectedCategory];
            let languageList = channelObj.allLanguageList[channelObj.selectedLanguage];
            let arr = categoryList.filter(value => languageList.includes(value));

            let channelListObj = setChannelListHandler(arr);
            updateChannelObj({
                ...channelListObj,
            })
        } else {
            updateChannelObj({
                channelList: channelData,
                categoryList: channelObj.allCategoryList ? Object.keys(channelObj.allCategoryList) : Object.keys(categoryGrouping || {}),
                languageList: channelObj.allLanguageList ? Object.keys(channelObj.allLanguageList) : Object.keys(languageGrouping || {})
            }); 
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [channelObj?.selectedCategory, channelObj?.selectedLanguage])

    const setChannelListHandler = (chanNumList) => {
        if(!chanNumList){
            return;
        }

        let channels = [];
        chanNumList.map(el => {
            channelData.map(obj => {
                if(el === obj.channelNumber){
                    channels.push(obj);
                }
            })
        })

        return {channelList:channels};
    }


    const setLanguageOptionsHandler = (categoryChannels) => {
        let filtetredLanguageOptions = []
        let i,j

        for(i=0; i<categoryChannels.length; i++ ){
            for (let x in channelObj.allLanguageList) {
                if(filtetredLanguageOptions.includes(x)){
                    // break;
                }
                if(channelObj.allLanguageList[x].some( ch =>  categoryChannels[i].includes(ch))){
                    filtetredLanguageOptions.push(x);
                    //  break;
                }
            }
        }

        filtetredLanguageOptions = Array.from(new Set(filtetredLanguageOptions))

        console.log('filtetredLanguageOptions', filtetredLanguageOptions)
        return filtetredLanguageOptions;
    }
    
    const setCategoryOptionsHandler = (languageChannels) => {
        let filtetredCategoryOptions = []
        let i,j

        for(i=0; i<languageChannels.length; i++ ){
            for (let x in channelObj.allCategoryList) {
                if(filtetredCategoryOptions.includes(x)){
                    // console.log('filtetredCategoryOptions.includes(x) include',filtetredCategoryOptions.includes(x), x)
                    break;
                }
                if(channelObj.allCategoryList[x].some( ch =>  languageChannels[i].includes(ch))){
                    filtetredCategoryOptions.push(x);
                    // console.log('filtetredCategoryOptions.includes(x)',filtetredCategoryOptions.includes(x), x)
                    break;
                }
            }
        }

        filtetredCategoryOptions = Array.from(new Set(filtetredCategoryOptions))

        console.log('filtetredCategoryOptions', filtetredCategoryOptions)
        return filtetredCategoryOptions;
    }

    const updateLoaderState = (loading, message) => {
        setLoaderState({
            showLoader: loading,
            loaderMessage: message
        })
    }
    const updateFetchApiError = (errorStatus, errorMessage, onContinueFunc=null, primaryBtnLabel, onCloseFunc=null, secondaryBtnLabel) => {
        setFetchApiError({
            errorStatus,
            errorMessage: errorStatus ? errorMessage : "",
            onContinueFunc: errorStatus ? onContinueFunc : null,
            primaryBtnLabel: errorStatus ? primaryBtnLabel : "",
            onCloseFunc: errorStatus ? onCloseFunc : null,
            secondaryBtnLabel: errorStatus ? secondaryBtnLabel : ""
        });
    };

    const sendCommand = (command) => {
        triggerHapticFeedback()
        
        let token = getToken(dispatch, roomRemoteDetails, currentTv)
        if (token) {
            dispatch(channelApi(token, command));
        }
    }

    const clickChannel = (channel) => {
        triggerHapticFeedback()

        let token = getToken(dispatch, roomRemoteDetails, currentTv);
        
        if(token) dispatch(channelApi(token, channel?.channelNumber, "setChannel"));
    }

    const handleMedialStreaming = (mediaName) => {
        triggerHapticFeedback()
            
        let token = getToken(dispatch, roomRemoteDetails, currentTv)
        
        dispatch(mediaStreamingLaunchApp(
            token, 
            mediaName, 
            currentTv?.deviceType, 
            (status, msg) => {
                dispatch(setRenderFlashMessage(true, { type: status ? "success" : "danger", message: msg }))
            }
        ))
    }

    const handleCallbackRemoteAccessApi = (status) => {
        setInitialLoading(false)
        updateLoaderState(false)

        if (!status) {
            return
        }
    }

    const handleRefreshToken = () => {
        updateLoaderState(true, "Loading devices...");
        dispatch(getremoteAccessToken(handleCallbackRemoteAccessApi));
    }

    const handleRefreshChannelList = () => {
        const channelScheduleHoursInt = parseInt(channelScheduleHours);
        dispatch(setIsChannelDataLoading(true));
        dispatch(fetchChannelList(channelScheduleHoursInt))
    }


    const initialiseRemote = () => {
        if(!isLoggedIn){
            dispatch(setGoHome(true));
            dispatch(setShowLoginModal(true));
            return;
        }

        if (!currentTv?.remoteSessionToken) {
            dispatch(setIsRoomRemoteLoading(true));

            setInitialLoading(true)
            dispatch(getremoteAccessToken(handleCallbackRemoteAccessApi));
        }
    }


    useEffect(() => {
        initialiseRemote();


        return () => {
            dispatch(setRoomRemoteDetails(null));
            dispatch(setChannelList([]))
            dispatch(setCurrentTv(null))
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        if(currentTv?.remoteSessionToken){
            dispatch(setIsMediaListLoading(true));
            dispatch(getMediaStreaming())

            handleRefreshChannelList()
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentTv?.remoteSessionToken])
    
    return <>
        {(!currentTv) && roomRemoteDetails?.length > 1 ? 
            appOrientation == LANDSCAPE ? 
                <TVSelect_Landscape /> 
                : <TVSelect_Potrait />
            : appOrientation == LANDSCAPE ? 
             <Remote_Landscape
                initialiseRemote={initialiseRemote} 
                handleRefreshToken={handleRefreshToken} 
                loading={loaderState.showLoader || initialLoading} 
                sendCommand={sendCommand}
                handleMedialStreaming={handleMedialStreaming}
                clickChannel={clickChannel}
                channelObj={channelObj}
                updateChannelObj={updateChannelObj}
                getTimeSlots={getTimeSlots}
                handleRefreshChannelList={handleRefreshChannelList}
            />
            : <Remote_Potrait
                initialiseRemote={initialiseRemote} 
                handleRefreshToken={handleRefreshToken} 
                loading={loaderState.showLoader || initialLoading} 
                sendCommand={sendCommand}
                handleMedialStreaming={handleMedialStreaming}
                clickChannel={clickChannel}
                channelObj={channelObj}
                updateChannelObj={updateChannelObj}
                getTimeSlots={getTimeSlots}
                handleRefreshChannelList={handleRefreshChannelList}
            />
        }

        
        {loaderState.showLoader && <FetchingDataScreen loaderMessage={loaderState.loaderMessage} />}
        {initialLoading && getDataLoadingScreen(INITIAL_LOADER_SCREEN)}


        {fetchApiError.errorStatus && 
            <InfoPopupModal
                subtitle={fetchApiError.errorMessage} 
                onContinue={fetchApiError.onContinueFunc ? fetchApiError.onContinueFunc : () => updateFetchApiError(false)}
                primaryBtnLabel={fetchApiError.primaryBtnLabel ? fetchApiError.primaryBtnLabel : "Close"} 
                onClose={fetchApiError.onCloseFunc ? fetchApiError.onCloseFunc : null}
                secondaryBtnLabel={fetchApiError.secondaryBtnLabel ? fetchApiError.secondaryBtnLabel : null}
        />}
    </>
}

